import headerImage from './img/jur_main.jpg';
import { StyledImage } from '../styled';

export default () => {
    return <StyledImage src={headerImage} alt='black and white photo of Deck Jurata'/>
}